import * as React from 'react'

import { Hero } from './sections/hero/Hero'
import { CustomSolutionsSection } from './sections/custom-solutions/CustomSolutionsSection'
import { CodeBlockWithTitle } from 'components/code-block-with-title/CodeBlockWithTitle'
import { GetStartedSection } from './sections/get-started/GetStartedSection'
import { ExploreProductsSection } from '../../components/explore-products-section/ExploreProductsSection'

const defaultCodeContent = `template <class Context>
__device_fct void process(Context context, __device_addr iir::ProcessorParameter* processor_param, __device_addr iir::TaskParameter* task_param,
    __device_addr float* __device_addr* input, __device_addr float* __device_addr* output) __device_addr {
    if (context.threadId() == 0) {
        dsp::StateSpaceFilterCoefficientsCalculator<TSample>::convertSosToStateSpace4(processor_param->coeffs, m_coeffs);
    }
    context.synchronize();

    auto warp_context = context.template slice<iir::SliceSize>();
    const uint32_t channel = warp_context.groupId();

    // TODO: On amd/mac warp primitives have to be called by the full warp!
    if (channel < processor_param->channel_count) {
        const uint32_t buffer_capacity = processor_param->buffer_capacity;

        // pointer to the first input sample in the block's channel
        __device_addr TSample* channel_input = input[0] + channel * buffer_capacity;
        // pointer to the first output sample in the block's channel
        __device_addr TSample* channel_output = output[0] + channel * buffer_capacity;

        m_processor.process(warp_context, channel_input, channel_output, processor_param->buffer_length, m_coeffs);
    }
}`

export const SDKPage: React.FC = () => {
  return (
    <>
      <Hero />
      <CustomSolutionsSection />
      <CodeBlockWithTitle
        heading="Real-time GPU Audio Processing In Just a Few Lines of Code"
        body="Here's how to implement parallel IIR processing that would be impossible on CPU"
        code={defaultCodeContent}
        button={{ text: 'Download SDK', to: '/resources' }}
      />
      <GetStartedSection />
      <ExploreProductsSection />
    </>
  )
}
